import AsyncBaseDownloadAssetsPresenterFactory from './AsyncBaseDownloadAssetsPresenterFactory';

export default class AsyncDownloadAssetsPresenterFactory
	extends AsyncBaseDownloadAssetsPresenterFactory {
	forDownloadAsset( {
		asset, withRoundNumber, allRounds, lowRes, withMarkups, assetSystem, snackbarSystem, onFinish, unpreviewable
	} ) {
		return this._forDownloadAssets( {
			action: () => assetSystem.downloadAsset( {
				asset, withRoundNumber, allRounds, lowRes, withMarkups, unpreviewable
			} ),
			onFinish,
			snackbarSystem
		} );
	}

	forDownloadAssets( {
		assets, folders, lowRes, withRoundNumber, projectSystem, snackbarSystem, onFinish, unpreviewable
	} ) {
		const projectID = assets?.[ 0 ]?.projectID || folders?.[ 0 ]?.projectID;
		const assetIDs = assets.map( asset => asset.id );
		const folderIDs = folders?.map( folder => folder.id );
		return this._forDownloadAssets( {
			action: () => projectSystem.downloadItems( {
				projectID, assetIDs, folderIDs, withRoundNumber, lowRes, unpreviewable
			} ),
			onFinish,
			snackbarSystem
		} );
	}
}
